import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { locationVerification } from "../api/user.api";
import { getFirebaseAuth } from "../firebase";
import { onAuthStateChanged, onIdTokenChanged } from "firebase/auth";
import {
    getItemFromLocalStorage,
    setItemToLocalStorage,
} from "../utils/localStorage";
import { TOKEN } from "../constants/const";
import { logout } from "../hooks/logout";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import GlobalLoader from "../services/GlobalLoader";
import { getOngoingGame } from "../api/game.api";
import { navigate } from "gatsby";

export const queryClient = new QueryClient();

const Root = ({ children }) => {
    const [blocked, setBlocked] = useState(false);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        if (typeof window === "undefined") return;

        const auth = getFirebaseAuth();

        const unsubscribe = onAuthStateChanged(auth, async (u) => {
            if (u) {
                try {
                    const idToken = await u.getIdToken(true);
                    setItemToLocalStorage(TOKEN, idToken);
                    try {
                        const ongoingGame = await getOngoingGame();
                        if (ongoingGame?.id) {
                            navigate(
                                `/dashboard/games/${ongoingGame.name}/?value=Solitaire&tournamentId=${ongoingGame.tournamentId}`
                            );
                        }
                    } catch {}
                } catch (err) {
                    await logout();
                    queryClient.invalidateQueries({ queryKey: ["user"] });
                    queryClient.invalidateQueries();
                }
            } else {
                await logout();
                queryClient.invalidateQueries({ queryKey: ["user"] });
                queryClient.invalidateQueries();
            }
        });

        const unsubscribeIdToken = onIdTokenChanged(auth, async (u) => {
            const currentToken = getItemFromLocalStorage(TOKEN);
            const idToken = await u?.getIdToken();
            if (currentToken && idToken && currentToken !== idToken) {
                setItemToLocalStorage(TOKEN, idToken);
            }
        });

        return () => {
            unsubscribe();
            unsubscribeIdToken();
        };
    }, []);

    useEffect(() => {
        const validateLocation = async () => {
            try {
                const res = await locationVerification();
                if (res.statusCode === 403) {
                    setBlocked(true);
                }
            } catch (err) {
                console.error("Validation error", err);
            } finally {
                setLoading(false);
            }
        };

        validateLocation();
    }, []);

    if (loading) return <GlobalLoader />;

    return (
        <QueryClientProvider client={queryClient}>
            {/*<ReactQueryDevtools initialIsOpen />*/}
            <div className="relative">
                {/*<DailyBonusPopup />*/}
                {blocked ? (
                    <div className="fixed inset-0 bg-black bg-opacity-80 z-50 flex items-center justify-center">
                        <div className="bg-[#1a103d] text-white rounded-2xl p-8 max-w-md text-center shadow-2xl border border-purple-700">
                            <h2 className="text-xl font-bold text-purple-400 mb-4">
                                Access Denied
                            </h2>
                            <p className="mb-4 text-white">
                                Access denied: Restricted in your current state
                                or region.
                            </p>
                        </div>
                    </div>
                ) : (
                    children
                )}
            </div>
        </QueryClientProvider>
    );
};
Root.propTypes = {
    children: PropTypes.node.isRequired,
};

export default Root;
